// import dayjs from "dayjs";
// import advancedFormat from "dayjs/plugin/advancedFormat";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEye, faFilePdf, faStar } from "@fortawesome/free-solid-svg-icons";
// import { formatDateVN } from "../../../utils/formatUtils";

// export default function TaskReportTable({ data, loading, onViewDetail }) {
//   return (
//     <div className="bg-white rounded-lg shadow border border-gray-200 overflow-hidden">

//       {/* ====================== LOADING ====================== */}
//       {loading && (
//         <div className="p-6">
//           <p className="text-gray-500 italic text-sm">Đang tải báo cáo...</p>
//         </div>
//       )}

//       {/* ====================== KHÔNG CÓ DỮ LIỆU ====================== */}
//       {!loading && data.length === 0 && (
//         <div className="p-6 text-center">
//           <p className="text-gray-500 italic text-sm">Chưa có báo cáo nào.</p>
//         </div>
//       )}

//       {/* ====================== BẢNG DỮ LIỆU ====================== */}
//       {!loading && data.length > 0 && (
//         <div className="border rounded-md overflow-x-auto">
//           <table className="w-full table-auto text-sm bg-white">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="p-3 text-gray-600 text-center">Chi nhánh</th>
//                 <th className="p-3 text-gray-600 text-center">Nhân viên</th>
//                 <th className="p-3 text-gray-600 text-center">Bộ phận</th>
//                 <th className="p-3 text-gray-600 text-center min-w-120">Từ ngày</th>
//                 <th className="p-3 text-gray-600 text-center min-w-120">Đến ngày</th>
//                 <th className="p-3 text-gray-600 text-center min-w-90">Đăng ký</th>
//                 <th className="p-3 text-gray-600 text-center min-w-90">Được giao</th>
//                 <th className="p-3 text-gray-600 text-center min-w-90">Không duyệt</th>
//                 <th className="p-3 text-gray-600 text-center min-w-90">Hoàn thành</th>
//                 <th className="p-3 text-gray-600 text-center min-w-90">Điểm trung bình</th>
//                 <th className="p-3 text-gray-600 text-right">Thao tác</th>
//               </tr>
//             </thead>

//             <tbody>
//               {data.map((r, idx) => (
//                 <tr key={idx} className="border-b hover:bg-gray-50 transition">
//                   <td className="p-4">{r.branch_name}</td>
//                   <td className="p-4 font-medium">{r.employee_name}</td>
//                   <td className="p-4">{r.department_name}</td>
//                   <td className="p-4 text-center">{formatDateVN(r.from_date)}</td>
//                   <td className="p-4 text-center">{formatDateVN(r.to_date)}</td>

//                   <td className="p-4 text-center font-semibold">
//                     {r.registered_tasks === 0 ? "–" : r.registered_tasks}
//                   </td>

//                   <td className="p-4 text-center text-indigo-600 font-semibold">
//                     {r.assigned_tasks === 0 ? "–" : r.assigned_tasks}
//                   </td>

//                   <td className="p-4 text-center text-pink-600 font-semibold">
//                     {r.rejected_tasks === 0 ? "–" : r.rejected_tasks}
//                   </td>

//                   <td className="p-4 text-center text-green-600 font-semibold">
//                     {r.completed_tasks === 0 ? "–" : r.completed_tasks}
//                   </td>

//                   <td className="p-4 text-center text-yellow-600 font-semibold">
//                     {r.avg_completed_point > 0 && (
//                       <FontAwesomeIcon icon={faStar} size="sm" className="mr-1" />
//                     )}
//                     {!r.avg_completed_point
//                       ? "–"
//                       : Number(r.avg_completed_point).toFixed(2)}
//                   </td>

//                   {/* ====================== THAO TÁC ====================== */}
//                   <td className="p-4 text-right">
//                     <div className="flex items-center justify-end gap-4">

//                       {/* 👁 Xem chi tiết */}
//                       {/* <button
//                         title="Xem chi tiết"
//                         className="text-blue-600 hover:text-blue-800 transition"
//                         onClick={() => onViewDetail && onViewDetail(r)}
//                       >
//                         <FontAwesomeIcon icon={faEye} size="lg" />
//                       </button> */}

//                       {/* 📄 PDF */}
//                       {r.pdf_url && (
//                         <a
//                           href={r.pdf_url}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-red-600 hover:text-red-800 transition"
//                           title="Tải PDF"
//                         >
//                           <FontAwesomeIcon icon={faFilePdf} size="lg" />
//                         </a>
//                       )}

//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faStar,
  faCalendarAlt,
  faInbox,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import { formatDateVN } from "../../../utils/formatUtils";

export default function TaskReportTable({ data, loading, onViewDetail, currentPage = 1, pageSize = 10 }) {
  const getAttachmentUrl = (r) =>
    r?.attachment_url ||
    r?.attachment_file_url ||
    r?.report_attachment_url ||
    r?.attached_pdf_url ||
    "";

  const StatBadge = ({ value, colorClass }) => {
    if (!value || value === 0) return <span className="text-gray-300">—</span>;
    return (
      <span className={`px-2 py-0.5 rounded text-xs font-bold ${colorClass}`}>
        {value}
      </span>
    );
  };

  return (



<div className="w-full bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
  {/* 1. LOADING STATE */}
  {loading && (
    <div className="flex flex-col items-center justify-center p-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
      <p className="text-gray-500 text-sm">Đang tải dữ liệu...</p>
    </div>
  )}

  {/* 2. TABLE STRUCTURE (Luôn hiện Header nếu không loading) */}
  {!loading && (
    <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-gray-50/80 border-b border-gray-100">
            <th className="px-4 py-4 text-[11px] font-bold uppercase text-gray-400 text-center w-12">STT</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400">Chi nhánh</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400">Nhân viên / Bộ phận</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400">Khoảng thời gian</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400 text-center">Chỉ số Task</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400 text-center">Điểm TB</th>
            <th className="px-6 py-4 text-[11px] font-bold uppercase text-gray-400 text-right w-20">File</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-50">
          {data.length > 0 ? (
            // CÓ DỮ LIỆU: Map qua từng phần tử
            data.map((r, idx) => (
              <tr
                key={idx}
                onClick={() => onViewDetail && onViewDetail(r)}
                className="group hover:bg-blue-50/50 cursor-pointer transition-all duration-150"
              >
                <td className="px-4 py-4 text-center text-gray-400 text-sm font-medium">
                  {((currentPage - 1) * pageSize) + idx + 1}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">{r.branch_name}</td>
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-gray-100 to-gray-200 text-gray-600 flex items-center justify-center font-bold text-[10px] mr-3 group-hover:from-red-100 group-hover:to-red-200 group-hover:text-red-700 transition-colors">
                      {r.employee_name?.split(" ").pop()?.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-800 group-hover:text-red-700 transition-colors">{r.employee_name}</div>
                      <div className="text-[11px] text-gray-500">{r.department_name}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center text-gray-600 bg-gray-50 group-hover:bg-white px-3 py-1.5 rounded-lg border border-transparent group-hover:border-blue-100 transition-all w-fit">
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-[10px] mr-2 text-gray-400" />
                    <span className="text-xs font-medium">{formatDateVN(r.from_date)}</span>
                    <span className="mx-2 text-gray-300 text-[10px]">→</span>
                    <span className="text-xs font-medium">{formatDateVN(r.to_date)}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-center">
                   {/* ... (Các StatBadge giữ nguyên logic) ... */}
                   <div className="flex items-center justify-center gap-1.5">
                      <StatBadge value={r.registered_tasks} colorClass="bg-gray-100 text-gray-600" />
                      <StatBadge value={r.assigned_tasks} colorClass="bg-blue-50 text-blue-600" />
                      <StatBadge value={r.rejected_tasks} colorClass="bg-red-50 text-red-600" />
                      <StatBadge value={r.completed_tasks} colorClass="bg-green-50 text-green-600" />
                   </div>
                </td>
                <td className="px-6 py-4 text-center">
                  {!r.avg_completed_point ? "—" : (
                    <div className="inline-flex items-center font-bold text-gray-700">
                      <span className="text-sm">{Number(r.avg_completed_point).toFixed(2)}</span>
                      <FontAwesomeIcon icon={faStar} className="text-[10px] ml-1 text-yellow-400" />
                    </div>
                  )}
                </td>
                <td className="px-6 py-4 text-right" onClick={(e) => e.stopPropagation()}>
                  <div className="flex items-center justify-end gap-1.5">
                    {r.pdf_url && (
                      <a
                        href={r.pdf_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center w-8 h-8 text-red-500 hover:bg-red-50 rounded-full transition-colors"
                        title="Mở báo cáo PDF tổng hợp"
                      >
                        <FontAwesomeIcon icon={faFilePdf} />
                      </a>
                    )}
                    {getAttachmentUrl(r) && (
                      <a
                        href={getAttachmentUrl(r)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center w-8 h-8 text-blue-500 hover:bg-blue-50 rounded-full transition-colors"
                        title="Mở file đính kèm"
                      >
                        <FontAwesomeIcon icon={faPaperclip} />
                      </a>
                    )}
                    {!r.pdf_url && !getAttachmentUrl(r) && (
                      <span className="text-gray-300 text-sm">—</span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            // KHÔNG CÓ DỮ LIỆU: Hiện dòng thông báo trong bảng
            <tr>
              <td colSpan="7" className="px-6 py-12 text-center">
                <div className="flex flex-col items-center justify-center text-gray-400">
                  <FontAwesomeIcon icon={faInbox} className="text-3xl mb-3 opacity-20" />
                  <p className="text-sm italic">Không tìm thấy báo cáo nào phù hợp với bộ lọc hiện tại.</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )}
</div>
  );
}
